import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class TariffDetailsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    try {
      const view = this.getView(route);
      if (view) {
        return await this.routeGuardService.handleRoute(view, route);
      }
      return true;
    } catch (error) {
      console.error('[TariffDetailsViewGuard] ❌ Error in canActivate:', error);
      return false;
    }
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `tariffs/${uuid}`,
      iframeUrl: `tarif/${uuid}`,
    };
  }
}
